import React, { useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import NavigationHelper from 'layers/navigation/navigationHelper'

import LessonList from './component'
import {
  buildLessonItems,
  findNextLessonIndex,
  getUnitResourceUrl,
} from './utils'

export const LessonListContainer = ({
  contentfulLessons,
  dataTestId,
  displayAsAccordion,
  gradeTheme,
  lessonStartingIndex = 1,
  lessonSummaries,
  lessons,
  match,
  navigationEvent,
  unitResources,
}) => {
  const [aLessonIsOpen, setALessonIsOpen] = useState(false)
  const [selectedLessonAB, setSelectedLessonAB] = useState(null)
  const [selectedLessonIndex, setSelectedLessonIndex] = useState(1)
  const [useDefaultLessonAB, setUseDefaultLessonAB] = useState(true)

  const toggleSelectedLessonAB = useCallback(
    (selectedLesson, index) => {
      setUseDefaultLessonAB(false)
      setSelectedLessonAB(selectedLesson)
      if (index !== undefined) {
        setSelectedLessonIndex(lessonStartingIndex + index)
      }
    },
    [lessonStartingIndex],
  )

  const onDownloadResource = useCallback(
    href => {
      navigationEvent(href, NavigationHelper.types.DOWNLOAD_LINK)
    },
    [navigationEvent],
  )

  useEffect(() => {
    setALessonIsOpen(false)
    setSelectedLessonIndex(
      findNextLessonIndex({ lessonStartingIndex, lessons }),
    )
  }, [lessons, lessonStartingIndex])

  const lessonItems = useMemo(
    () =>
      buildLessonItems({
        aLessonIsOpen,
        contentfulLessons,
        lessonStartingIndex,
        lessonSummaries,
        lessons,
        selectedLessonAB,
        selectedLessonIndex,
        useDefaultLessonAB,
      }),
    [
      aLessonIsOpen,
      contentfulLessons,
      lessonStartingIndex,
      lessonSummaries,
      lessons,
      selectedLessonAB,
      selectedLessonIndex,
      useDefaultLessonAB,
    ],
  )

  const lessonPlanUrl = unitResources
    ? getUnitResourceUrl(unitResources[0])
    : null
  const studentHandoutsUrl = unitResources
    ? getUnitResourceUrl(unitResources[1])
    : null
  const lessonLastIndex = lessonStartingIndex - 1 + lessons.length
  const showLessonsHeader = lessons.length > 1

  return (
    <LessonList
      dataTestId={dataTestId}
      displayAsAccordion={displayAsAccordion}
      gradeTheme={gradeTheme}
      lessonItems={lessonItems}
      lessonLastIndex={lessonLastIndex}
      lessonPlanUrl={lessonPlanUrl}
      lessonStartingIndex={lessonStartingIndex}
      match={match}
      onDownloadResource={onDownloadResource}
      setALessonIsOpen={setALessonIsOpen}
      setSelectedLessonIndex={setSelectedLessonIndex}
      showLessonsHeader={showLessonsHeader}
      studentHandoutsUrl={studentHandoutsUrl}
      toggleSelectedLessonAB={toggleSelectedLessonAB}
      unitResources={unitResources}
    />
  )
}

LessonListContainer.propTypes = {
  contentfulLessons: PropTypes.array.isRequired,
  dataTestId: PropTypes.string.isRequired,
  displayAsAccordion: PropTypes.bool,
  gradeTheme: PropTypes.string,
  lessonStartingIndex: PropTypes.number,
  lessonSummaries: PropTypes.array,
  lessons: PropTypes.array.isRequired,
  match: PropTypes.object.isRequired,
  navigationEvent: PropTypes.func,
  unitResources: PropTypes.array,
}

export default connect(
  null,
  NavigationHelper.mapDispatchToProps,
)(LessonListContainer)
